'use strict';

// eslint-disable-next-line max-lines-per-function, max-params
angular.module('webAgro1App').factory('MapaService', function($http, $q, LeafletService, KNOTS_TO_KM_H) {
  const VELOCIDADE_MAXIMA = 25.0;
  const VELOCIDADE_MINIMA = 15.0;
  const MAX_LINES = 5;
  const MAXIMUM_INDEX = 99999;
  const INDICE_MAXIMA = 0;
  const INDICE_MINIMA = 1;

  return {
    getCoordinateCentroid: function(coordinates) {
      const PI = 22/7;
      let coordX = 0;
      let coordY = 0;
      let coordZ = 0;
      for (let i = 0; i < coordinates.length; i++) {
        let lat1 = coordinates[i].latitude;
        let lon1 = coordinates[i].longitude;
        lat1 = lat1 * PI/180;
        lon1 = lon1 * PI/180;
        coordX += Math.cos(lat1) * Math.cos(lon1);
        coordY += Math.cos(lat1) * Math.sin(lon1);
        coordZ += Math.sin(lat1);
      }
      let lon = Math.atan2(coordY, coordX);
      // eslint-disable-next-line no-mixed-operators
      const hyp = Math.sqrt(coordX * coordX + coordY * coordY);
      let lat = Math.atan2(coordZ, hyp);
      lat = lat * 180/PI;
      lon = lon * 180/PI;

      return { latitude: lat, longitude: lon };
    },

    isInsideCoordinatesPolygon: function(coordinate, coordinatesPolygon) {
      const coordinateCheck = this.getGoogleMapsLatLng(coordinate);
      const polygonCheck = this.getGoogleMapsPolygon(coordinatesPolygon);
      return google.maps.geometry.poly.containsLocation(coordinateCheck, polygonCheck);
    },

    getGoogleMapsLatLng: function(coordinate) {
      const latLng = new google.maps.LatLng(coordinate.latitude, coordinate.longitude);
      latLng.altitude = coordinate.latitude;
      latLng.speed = coordinate.speed;
      latLng.bearing = coordinate.bearing;
      latLng.accuracy = coordinate.accuracy;
      return latLng;
    },

    getGoogleMapsPolygon: function(coordinates) {
      const coords = [];
      for (let i = coordinates.length - 1; i >= 0; i--) {
        coords.push(this.getGoogleMapsLatLng(coordinates[i]));
      }
      return new google.maps.Polygon({
        paths: coords,
        layer: google.maps.drawing.OverlayType.POLYGON
      });
    },

    getLeafletPolygon: function(coordinates, options) {
      const coords = coordinates.map(function(coordinate) {
        return L.latLng(coordinate.latitude, coordinate.longitude, coordinate.latitude);
      });
      if (!options) {
        const polygon = L.polygon(coords);
        polygon.coordinate = coordinates;
        return polygon;
      }

      const polygon = L.polygon(coords, options);
      polygon.coordinate = coordinates;
      return polygon;
    },

    getAndValidateSpeedIntervals: function(faixas) {
      if (faixas) {
        if (faixas[INDICE_MAXIMA] < faixas[INDICE_MINIMA]) {
          return {
            velocidadeMinima: faixas[INDICE_MAXIMA],
            velocidadeMaxima: faixas[INDICE_MINIMA]
          };
        }

        return {
          velocidadeMinima: faixas[INDICE_MINIMA],
          velocidadeMaxima: faixas[INDICE_MAXIMA]
        };
      }

      return {
        velocidadeMinima: VELOCIDADE_MINIMA,
        velocidadeMaxima: VELOCIDADE_MAXIMA
      };
    },

    // eslint-disable-next-line complexity
    getColorFromSpeed: function(speed, faixas) {
      faixas = faixas || [];
      let color = 'black';
      const speedIntervals = this.getAndValidateSpeedIntervals(faixas);

      if (speed > 0 && speed < speedIntervals.velocidadeMinima) {
        color = 'green';
      } else if (speed >= speedIntervals.velocidadeMinima && speed < speedIntervals.velocidadeMaxima) {
        color = 'yellow';
      } else if (speed >= speedIntervals.velocidadeMaxima) {
        color = 'red';
      }

      return color;
    },

    getGoogleMapsPolyline: function(coordinates) {
      const _this = this;
      const poly = new google.maps.Polyline();
      const path = coordinates.map(function(coordinate) {
        return _this.getGoogleMapsLatLng(coordinate);
      });
      poly.setPath(path);
      poly.layer = google.maps.drawing.OverlayType.POLYLINE;
      return poly;
    },

    // eslint-disable-next-line max-lines-per-function
    getGoogleMapsPolylineWithObject: function(objeto) {
      const _this = this;
      const poly = [];
      let prevLatLang = '';
      objeto.pontos.forEach(function(coordinate, index) {
        const currentLatLng = new google.maps.LatLng(coordinate.latitude, coordinate.longitude);
        if (prevLatLang === '') {
          prevLatLang = currentLatLng;
        } else {
          coordinate.speed = ((coordinate.speed || 0) * KNOTS_TO_KM_H).toFixed(2);
          const color = _this.getColorFromSpeed(coordinate.speed, objeto.faixas);
          const polyline = new google.maps.Polyline({
            path: [prevLatLang, currentLatLng],
            geodesic: true,
            strokeColor: color,
            fillColor: color,
            strokeOpacity: 1.0,
            strokeWeight: 5,
            zIndex: MAXIMUM_INDEX - index
          });

          if (index % MAX_LINES === 0) {
            polyline.setOptions({ icons: [_this.getPolylineIcon('white')] });
          }
          prevLatLang = currentLatLng;
          polyline.area = objeto.area;
          polyline.layer = google.maps.drawing.OverlayType.POLYLINE;
          polyline.coordinate = coordinate;
          poly.push(polyline);
        }
      });

      return poly;
    },

    getLeafletPolylineWithObject: function(objeto) {
      const _this = this;
      const poly = [];
      let prevLatLang = '';
      objeto.pontos.forEach(function(coordinate) {
        const currentLatLng = L.latLng(coordinate.latitude, coordinate.longitude, coordinate.altitude);
        if (prevLatLang === '') {
          prevLatLang = currentLatLng;
        } else {
          coordinate.speed = ((coordinate.speed || 0) * KNOTS_TO_KM_H).toFixed(2);
          const color = _this.getColorFromSpeed(coordinate.speed, objeto.faixas);
          const polyline = L.polyline([prevLatLang, currentLatLng], {
            color,
            weight: 5
          });

          prevLatLang = currentLatLng;
          polyline.area = objeto.area;
          polyline.coordinate = coordinate;
          poly.push(polyline);
        }
      });

      return poly;
    },

    getPolylineIcon: function(cor) {
      return {
        icon: {
          path: google.maps.SymbolPath.FORWARD_OPEN_ARROW,
          strokeColor: cor || '#0b763e',
          strokeWeight: 2,
          strokeOpacity: 1,
          scale: 1.5
        },
        repeat: '50px'
      };
    },

    createStartEndMarkers: function(start, end) {
      const markers = [];
      let coordinate = {
        lat: parseFloat(start.latitude),
        lng: parseFloat(start.longitude)
      };

      const firstmarker = this.createLeafletFontAwesomeMarker(coordinate, 'flag', 'white');

      markers.push(firstmarker);

      coordinate = {
        lat: parseFloat(end.latitude),
        lng: parseFloat(end.longitude)
      };

      const lastMarker = this.createLeafletFontAwesomeMarker(coordinate, 'flag-checkered', 'red');
      markers.push(lastMarker);
      return markers;
    },

    addStartEndMarkers: function(markers) {
      markers.forEach(function(marker) {
        LeafletService.addToMap(marker, 'propriedade-map');
      });
    },

    removeStartEndMarkers: function(markers) {
      markers.forEach(function(marker) {
        LeafletService.removeFromMap(marker, 'propriedade-map');
      });
    },

    createLeafletFontAwesomeMarker: function(coordinate, name, color) {
      return LeafletService.createMarker([coordinate.lat, coordinate.lng], LeafletService.fontAwesomeIcon(name, color));
    },

    setIconPolylines: function(polylines, cor) {
      const _this = this;
      return polylines.map(function(polyline) {
        polyline.icons = [_this.getPolylineIcon(cor)];
        return polyline;
      });
    },

    setMarkersMap: function(records, map) {
      records.forEach(function(record) {
        record.marker.setMap(map || null);
      });
    },

    setToMap: function(records, map) {
      (records || []).forEach(function(record) {
        record.setMap(map || null);
        if (record.markerLabel) {
          record.markerLabel.setMap(map || null);
        }
      });
    },

    resetMapLayers: function(map) {
      map = map.map || map;
      return $q(function(resolve) {
        if (map.overlayMapTypes.length > 0) {
          map.overlayMapTypes.clear();
        }
        resolve(map);
      });
    },

    convertDMSToDD: function(coordinate) {
      if (isNaN(coordinate)) {
        const values = coordinate.toString().split(/[^\d\w]+/);
        const degrees = values[0];
        const minutes = values[1];
        const seconds = values[2];

        // eslint-disable-next-line no-mixed-operators
        let dd = Number(degrees) + Number(minutes)/60 + Number(seconds)/(60*60);

        dd = dd * -1; // considera para todos os clientes direções  S e W
        return dd;
      }
      return coordinate;
    }

  };
});
